import { memo } from 'react';
import SimpleModelResponseSelectorTaskComponent from './SimpleModelResponseSelectorTaskComponent';
import { StepViewComponentProps } from '../stepDescriptor/types';

const ModelResposeSelectorViewComponent = ({
  responseIndex,
  readOnly,
  complete,
}: StepViewComponentProps) => {
  return (
    <SimpleModelResponseSelectorTaskComponent
      responseIndex={responseIndex}
      complete={complete}
      readOnly={readOnly}
      isPinnable
      isPinnedView={false}
    />
  );
};

export default memo(ModelResposeSelectorViewComponent);
